import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

function useCustomerDataLoading() {
    const [isCustomerDataLoading, setCustomerDataLoading] = useState(true);
    return { isCustomerDataLoading, setCustomerDataLoading };
}

export const CustomerDataLoadingStore = createStore(useCustomerDataLoading);
